@switch (format()) {
  @case ('staaende') {
    <ng-template #valgtittlerFragment>
      <tr>
        @for (alternativOgResultat of staaendeData(); track alternativOgResultat.alternativ.verdi) {
          <td class="tittel" [style.width.px]="alternativOgResultat.kontainerbreddePx"> {{ alternativOgResultat.alternativ.tittel }}</td>
        }
      </tr>
    </ng-template>

    <table class="stående">
      <thead [class.titler-under]="visValgtittelUnder()">
        @if (visValgtittelOver()) {
          <ng-container *ngTemplateOutlet="valgtittlerFragment"/>
        }
       <!-- viser kun sub-tittel dersom mer enn en resultatsamling er angitt -->
        @if (resultater().length > 1 && oppsett()?.visValgtittel != false) {
          <tr>
            @for (alternativOgResultat of staaendeData(); track alternativOgResultat.alternativ.verdi) {
              <td class="sub-tittel-kontainer" [style.width.px]="alternativOgResultat.kontainerbreddePx">
                <table>
                  <tr>
                    @for (resultat of alternativOgResultat.resultat; track resultat.id; ) {
                      <td class="sub-tittel" [style.width.%]="resultat.breddeProsent" matTooltip="{{ resultat.tittel }}">
                        {{ resultat.tittelKort }}
                      </td>
                    }
                  </tr>
                </table>
              </td>
            }
          </tr>
        }
        @if (visValgtittelUnder()) {
          <ng-container *ngTemplateOutlet="valgtittlerFragment"/>
        }
      </thead>
      <tbody>
      <tr class="søyler">
        @for (alternativOgResultat of staaendeData(); track alternativOgResultat.alternativ.verdi) {
          <td class="søyle-kontainer" [style.width.px]="alternativOgResultat.kontainerbreddePx" [style.height.px]="diagramHoeydePx()">
            <table class="sub-søyler">
              <tr>
                @for (resultat of alternativOgResultat.resultat; track resultat.id; let erPrimaerUndersoekelse = $last;) {
                  <td class="sub-søyle-kontainer" [style.width]="resultat.breddeProsent + '%'">
                    <div class="søyle"
                         [style.height.%]="resultat.prosent * 100"
                         [style.background-color]="bakgrunnsfargeForValg(alternativOgResultat.alternativ, !erPrimaerUndersoekelse)"
                         matTooltip="{{resultat.hjelpetekst}}">
                      <div class="verdi" data-testid="søyle-verdi">{{ resultat.prosent|percent }}</div>
                    </div>
                  </td>
                }
              </tr>
            </table>
          </td>
        }
      </tr>
      </tbody>
    </table>
  }
  @case ('liggendeKombinert') {
    <table class="liggende-kombinert">
      <tbody>
        @for (resultat of liggendeKombinertData(); track resultat.id; let erPrimaerUndersoekelse = $first) {
          <tr class="søyler">
            <!-- viser kun sub-tittel dersom mer enn en resultatsamling er angitt -->
            @if (resultater().length > 1) {
              <td class="sub-tittel" matTooltip="{{resultat.tittel}}" matTooltipPosition="before">{{ resultat.tittelKort }}</td>
            }
            <td class="søyle-kontainer">
              <table class="søyle-samling" [style.height.px]="resultat.hoeydePx">
                <tr>
                  @for (alternativ of resultat.alternativer; track alternativ.alternativ.alternativ.verdi;) {
                    @if (alternativ.alternativ.antall > 0) {
                      @let bakgrunnsfarge = bakgrunnsfargeForValg(alternativ.alternativ.alternativ, !erPrimaerUndersoekelse);
                      <td class="søyle"
                          [style.width.%]="alternativ.prosent * 100"
                          [style.background-color]="bakgrunnsfarge"
                          matTooltip="{{ alternativ.hjelpetekst }}">
                        <div class="verdi" [style.color]="tekstfargePaaBakgrunnsfarge(bakgrunnsfarge)" data-testid="søyle-verdi">
                          <!--{{ alternativ.alternativ.antall }}-->
                          {{ alternativ.prosent|percent }}
                          @if (visValgtittel.vises()) {
                           - {{ alternativ.alternativ.alternativ.tittel }}
                          }
                        </div>
                      </td>
                    }
                  }
                  @if (resultat.ingenData) {
                    <td class="søyle ingen-data">
                      <div class="verdi">
                        {{ 'ingen data'|translate }}
                      </div>
                    </td>
                  }
                </tr>
              </table>
            </td>
          </tr>
        }
      </tbody>
      @if (oppsett().visValgtittel != false && liggendeKombinertData().length > 0) {
        <tfoot>
        <tr>
          <!-- viser kun sub-tittel dersom mer enn en resultatsamling er angitt -->
          @if (resultater().length > 1) {
            <td></td>
          }
          <td>
            <div class="valg-kontainer">
              @for (alternativ of liggendeKombinertData()[0].alternativer; track alternativ.alternativ.alternativ.verdi) {
                <div class="valg">
                  <span class="farge-indikator" [style.background-color]="alternativ.alternativ.alternativ.farge"></span>
                  <span class="tittel">{{ alternativ.alternativ.alternativ.tittel }}</span>
                </div>
              }
              <a (click)="visValgtitlerIDiagram()" class="vis-valgtitler">
                <mat-icon inline="true">visibility</mat-icon>
                {{'Vis titler i diagrammet'|translate}}
              </a>
            </div>
          </td>
        </tr>
        </tfoot>
      }
    </table>
  }
}

